<template>
  <div>
    <div
      class="inout-detail absolute_center"
      style="width: 1620px"
      :class="{
        _boxBg_green_secondLevel: styleType == 'typeGreen',
        _boxBg_dark_secondLevel: styleType == 'typeDark',
        _boxBg_blue_secondLevel: styleType == 'typeBlue',
        _boxBg_strong_secondLevel: styleType == 'typeStrong',
      }"
    >
      <div class="inout_detail_top">
        <div class="detail_title">
          {{ newAccessType ? "运输车辆信息" : "车辆运输信息" }}
        </div>
        <div class="selfClose_btn" @click="close"></div>
      </div>
      <div class="list_overview_detail">
        <!-- <div class="selfClose_btn" style="top:10px"></div> -->

        <div class="account" style="height: auto">
          <div class="account-title">车辆基础信息</div>
          <div class="basic-info">
            <div class="basic-item">
              <label class="item-label">车牌号码：</label>
              <span>{{ carinfo && carinfo.numberPlate }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">发动机号码：</label>
              <span>{{ carinfo && carinfo.engineNumber }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">车辆识别代号(VIN)：</label>
              <span>{{ carinfo && carinfo.vin }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">注册日期：</label>
              <span>{{ carinfo && carinfo.registrationDate }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">排放阶段：</label>
              <span>
                {{ vehicleMissionsName[carinfo && carinfo.vehicleEmission] }}
              </span>
            </div>
            <div class="basic-item">
              <label class="item-label">车辆类型：</label>
              <span>{{
                carinfo && (carinfo.vehicleType || carinfo.vehicleUseType)
              }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">车牌颜色：</label>
              <span>{{ carinfo && carinfo.plateColor }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">燃料类型：</label>
              <span>{{ carinfo && carinfo.fuelType }}</span>
            </div>
            <div class="basic-item" v-if="customerId == 50">
              <div class="item-label">联网状态：</div>
              <span>{{
                carinfo && (carinfo.onlineStatus == "0" ? "未联网" : "已联网")
              }}</span>
            </div>
            <div class="basic-item" v-if="customerId == 50">
              <div class="item-label">核定载重质量：</div>
              <span>{{ carinfo && carinfo.approvedLoadMass }}</span>
            </div>
            <div class="basic-item" v-if="customerId == 50">
              <div class="item-label">最新年检日期：</div>
              <span>{{ carinfo && carinfo.latestInspectionDate }}</span>
            </div>
          </div>
          <div class="account-title">进厂信息</div>
          <div class="basic-info">
            <div class="basic-item">
              <label class="item-label">进厂时间：</label>
              <span>{{ carinfo && carinfo.inTime }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">进厂门岗：</label>
              <span v-if="customerId == 19">{{
                carinfo && carinfo.inGatePostName
              }}</span>
              <span v-else>
                {{
                  carinfo &&
                  (isPublicCleanTransport
                    ? carinfo.inGatePostName
                    : carinfo.inGatePostCode)
                }}</span
              >
            </div>
            <div class="basic-item">
              <label class="item-label">进厂称重单号：</label>
              <div class="special">
                {{ carinfo && carinfo.inTransportCode }}
              </div>
            </div>
            <div class="basic-item">
              <label class="item-label">进厂货物种类：</label>
              <span>{{ carinfo && carinfo.inTransportType }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">进厂货物名称：</label>
              <span>{{ carinfo && carinfo.inTransportName }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">进厂运输量（t)：</label>
              <span>{{ carinfo && carinfo.inTransportVolume }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">进厂计量时间：</label>
              <span>{{ carinfo && carinfo.inMeasureTime }}</span>
            </div>
          </div>
          <div class="account-title">出厂信息</div>
          <div class="basic-info">
            <div class="basic-item">
              <label class="item-label">出厂时间：</label>
              <span>{{ carinfo && carinfo.outTime }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">出厂门岗：</label>
              <span>
                {{
                  carinfo &&
                  (isPublicCleanTransport
                    ? carinfo.outGatePostName
                    : carinfo.outGatePostCode)
                }}</span
              >
            </div>
            <div class="basic-item">
              <label class="item-label">出厂称重单号：</label>
              <span class="item-limit">{{
                carinfo && carinfo.outTransportCode
              }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">出厂货物种类：</label>
              <span>{{ carinfo && carinfo.outTransportType }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">出厂货物名称：</label>
              <span>{{ carinfo && carinfo.outTransportName }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">出厂运输量（t)：</label>
              <span>{{ carinfo && carinfo.outTransportVolume }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">出厂计量时间：</label>
              <span>{{ carinfo && carinfo.outMeasureTime }}</span>
            </div>
          </div>
          <div class="account-title">其他信息</div>
          <div class="basic-info">
            <div class="basic-item">
              <label class="item-label">发货单位：</label>
              <span>{{ carinfo && carinfo.shipper }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">收货单位：</label>
              <span>{{ carinfo && carinfo.consignee }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">装卸货地点：</label>
              <span>{{ carinfo && carinfo.loadDischargeAddress }}</span>
            </div>
            <div class="basic-item">
              <label class="item-label">记录形式：</label>
              <span>{{ carinfo && carinfo.recordMode }}</span>
            </div>
          </div>
          <div class="account-title">车辆基础信息</div>
          <div class="picture-info2">
            <!-- <el-carousel :interval="4000" type="card" height="200px">
              <el-carousel-item v-for="item in 6" :key="item">
                <div class="picture-inner" @click="picture_click(info.drivingLicense)">
                  <div class="picture">
                    <img :src="carinfo&&carinfo.drivingLicense" />
                    <span>name</span>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>-->
            <div class="picture-info">
              <div
                class="picture-inner"
                v-if="customerId != 152 && customerId != 133"
                @click="picture_click(carinfo.inImage)"
              >
                <div class="picture">
                  <img
                    v-if="carinfo && carinfo.inImage"
                    :src="carinfo && carinfo.inImage"
                  />
                  <img v-else src="./img/no_img.png" />
                  <span>进厂图片</span>
                </div>
              </div>
              <div
                v-else
                class="picture-inner"
                @click="picture_click(carinfo.inImage)"
              >
                <div class="picture">
                  <img
                    v-if="carinfo.inImage"
                    :src="carinfo && carinfo.inImage"
                  />
                  <img v-else src="./img/no_img.png" />
                  <span>进厂图片1</span>
                </div>
              </div>
              <div
                v-if="customerId == 152 || customerId == 133"
                class="picture-inner"
                @click="picture_click(carinfo.inPlateImage)"
              >
                <div class="picture">
                  <img
                    v-if="carinfo.inPlateImage"
                    :src="carinfo && carinfo.inPlateImage"
                  />
                  <img v-else src="./img/no_img.png" />
                  <span>进厂图片2</span>
                </div>
              </div>
              <div
                class="picture-inner"
                v-if="customerId != 152 && customerId != 133"
                @click="picture_click(carinfo.outImage)"
              >
                <div class="picture">
                  <img
                    v-if="carinfo && carinfo.outImage"
                    :src="carinfo && carinfo.outImage"
                  />
                  <img v-else src="./img/no_img.png" />
                  <span>出厂图片</span>
                </div>
              </div>
              <div
                v-else
                class="picture-inner"
                @click="picture_click(carinfo.outImage)"
              >
                <div class="picture">
                  <img
                    v-if="carinfo.outImage"
                    :src="carinfo && carinfo.outImage"
                  />
                  <img v-else src="./img/no_img.png" />
                  <span>出厂图片1</span>
                </div>
              </div>
              <div
                v-if="customerId == 154 || customerId == 133"
                class="picture-inner"
                @click="picture_click(carinfo.outPlateImage)"
              >
                <div class="picture">
                  <img
                    v-if="carinfo.outPlateImage"
                    :src="carinfo && carinfo.outPlateImage"
                  />
                  <img v-else src="./img/no_img.png" />
                  <span>出厂图片2</span>
                </div>
              </div>
              <div
                class="picture-inner"
                @click="picture_click(carinfo.driverLicenseImageUrl)"
              >
                <div class="picture">
                  <img
                    v-if="carinfo && carinfo.driverLicenseImageUrl"
                    :src="carinfo && carinfo.driverLicenseImageUrl"
                  />
                  <img v-else src="./img/no_img.png" />
                  <span>行驶证</span>
                </div>
              </div>
              <div
                class="picture-inner"
                @click="picture_click(carinfo.onBoardListImageUrl)"
              >
                <div class="picture">
                  <img
                    v-if="carinfo && carinfo.onBoardListImageUrl"
                    :src="carinfo && carinfo.onBoardListImageUrl"
                  />
                  <img v-else src="./img/no_img.png" />
                  <span>随车清单</span>
                </div>
              </div>
              <div class="picture-inner" v-if="newAccessType && customerId != 50" @click="picture_click(carinfo.vehicleHeadImg)">
                <div class="picture">
                  <img
                    v-if="carinfo && carinfo.vehicleHeadImg"
                    :src="carinfo && carinfo.vehicleHeadImg"
                  />
                  <img v-else src="./img/no_img.png" />
                  <span>车头正面</span>
                </div>
              </div>
              <div class="picture-inner" @click="picture_click(carinfo.vehicleNameplate)" v-if="customerId != 50 && customerId != 133">
                <div class="picture">
                  <img
                    v-if="carinfo && carinfo.vehicleNameplate"
                    :src="carinfo && carinfo.vehicleNameplate"
                  />
                  <img v-else src="./img/no_img.png" />
                  <span>车身铭牌</span>
                </div>
              </div>
              <div class="picture-inner" v-if="newAccessType && customerId != 50" @click="picture_click(carinfo.vinVerificationImg)">
                <div class="picture">
                  <img
                    v-if="carinfo && carinfo.vinVerificationImg"
                    :src="carinfo && carinfo.vinVerificationImg"
                  />
                  <img v-else src="./img/no_img.png" />
                  <span>机动车环保网查询图片</span>
                </div>
              </div>
              <div class="picture-inner" v-if="newAccessType && customerId != 50" @click="picture_click(carinfo.vehicleLicenseVerificationImg)">
                <div class="picture">
                  <img
                    v-if="carinfo && carinfo.vehicleLicenseVerificationImg"
                    :src="carinfo && carinfo.vehicleLicenseVerificationImg"
                  />
                  <img v-else src="./img/no_img.png" />
                  <span>重型柴油车排放阶段查询图片</span>
                </div>
              </div>
              <div class="picture-inner" v-if="customerId === 133" @click="picture_click(carinfo.vehicleLicenseVerificationImg)">
                <div class="picture">
                  <img
                    v-if="carinfo && carinfo.vehicleLicenseVerificationImg"
                    :src="carinfo && carinfo.vehicleLicenseVerificationImg"
                  />
                  <img v-else src="./img/no_img.png" />
                  <span>重型柴油车排放阶段查询图片</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { dateFormat, deteleObject } from "@/utils/tools.js";
import imgBox from "./components/imgBox.vue";
export default {
  name: "inoutDetail_huale",
  props: ["globalInstance", "id", "createTime", "vehicleColor"],
  setup(props) {
    const id = props.id;
    const createTime = props.createTime;
    const vehicleColor = props.vehicleColor;

    const globalInstance = props.globalInstance;

    return { globalInstance, id, createTime, vehicleColor };
  },
  data() {
    return {
      electricVehicle: bmeConfig.electricVehicle,
      vehicleMissionsName: {
        0: "未知",
        1: "国Ⅰ",
        3: "国III",
        4: "国IV",
        5: "国V",
        6: "国VI",
        99: "新能源",
        // 101: "铁路运输",
        // 102: "水路运输",
        // 103: "管道或管状带式输送机",
      },
      customerId: this.globalInstance.$store.state.customerId,
      newAccessType: this.globalInstance.$store.state.newAccessType,
      prefix: "",
      styleType: "",
      carinfo: "",
      isPublicCleanTransport: bmeConfig.isPublicCleanTransport,
    };
  },
  computed: {
    ...mapGetters({
      dialogCompontent2: "getDialogCompontent2",
    }),
  },
  mounted() {},
  created() {
    this.getDetails();
    if (this.electricVehicle) {
      this.vehicleMissionsName["199"] = "纯电";
    }
  },
  watch: {},
  methods: {
    // 详情
    async getDetails() {
      let url =
        this.globalInstance.cleanTransportIp + "/vehicle/transport/details";
      let res;
      if (
        this.isPublicCleanTransport ||
        this.customerId == 89 ||
        this.customerId == 94 ||
        this.customerId == 58 ||
        this.customerId == 141 ||
        this.customerId == 142 ||
        this.customerId == 143
      ) {
        res = await this.globalInstance.$apiUtils.get3(url, {
          id: this.id,
          createTime: this.createTime,
          customerId: this.customerId,
        });
      } else {
        res = await this.globalInstance.$apiUtils.get(url, {
          id: this.id,
          customerId: this.customerId,
        });
      }

      // let res = {
      //   success: true,
      //   type: 0,
      //   msg: null,
      //   data: {
      //     id: 116955,
      //     numberPlate: '鲁Q936DW',
      //     vehicleUseType: null,
      //     fuelType: null,
      //     vehicleEmission: '6',
      //     plateColor: null,
      //     inTime: '2022-09-09T03:24:44.567+00:00',
      //     inGatePostCode: 'HL-W01',
      //     inTransportCode: null,
      //     inTransportType: null,
      //     inTransportName: '--',
      //     inTransportVolume: 0.0,
      //     inMeasureTime: null,
      //     outTime: null,
      //     outGatePostCode: null,
      //     outTransportCode: null,
      //     outTransportType: null,
      //     outTransportName: '--',
      //     outTransportVolume: 0.0,
      //     outMeasureTime: null,
      //     shipper: null,
      //     consignee: null,
      //     loadDischargeAddress: null,
      //     recordMode: null,
      //     vin: 'LZZ1CLWBXNJ232225',
      //     registrationDate: '20220518',
      //     engineNumber: '14211093522',
      //     driverLicenseImageUrl: null,
      //     onBoardListImageUrl: 'http://172.168.1.101:8181/220805/Vehicle_Board_list/LZZ1CLWBXNJ232225.jpg',
      //     nameplateImageUrl: null
      //   }
      // }
      this.carinfo = res;
      console.log(this.vehicleColor);

      if (this.vehicleColor) {
        this.carinfo.plateColor = this.vehicleColor;
      }
    },

    // async getData() {

    //   let url = this.globalInstance.cleanTransportIp + "/transport/inout_image";
    //   let res = await this.globalInstance.$apiUtils.get(url, this.paramsImage);
    //   this.info = res;
    //   this.tableData = res.materialList?res.materialList: []
    //   this.pictureArr[0].img = res?.inOutImage && res.inOutImage[0]?.inoutImage;
    //   this.pictureArr[1].img = res?.detail && res.detail?.drivingLicenseImage;
    //   this.pictureArr[2].img = res?.detail && res.detail?.onBoardList;
    //   if (this.customerId == 63) {
    //     this.pictureArr = [this.pictureArr[0], this.pictureArr[1]];
    //   }
    //   if (this.customerId == 23) {//新天钢
    //     this.pictureArr = [this.pictureArr[0], this.pictureArr[1]];
    //     this.pictureArr[1].name = '行驶证/随车清单';
    //   }
    //   if(this.customerId == 59) {
    //     this.hualeTableData();
    //   }
    // },

    picture_click(url) {
      if (!url) return;
      this.globalInstance.$store.commit("dialogStatus2", true);
      this.globalInstance.$popup.open2(imgBox, this.dialogCompontent2, this, {
        imgurl: url,
      });
    },
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
    },
  },
};
</script>
<style lang="scss">
.inout-detail {
  .table_box {
    .el-table {
      background: transparent;
      border: 1px solid rgba(132, 170, 255, 0.5);
    }
    .el-table .el-table__header-wrapper .el-table__header .has-gutter {
      height: 50px;
      background: rgba(1, 18, 43, 0.81) !important;
      border: 1px solid rgba(132, 170, 255, 0.5);
    }
    .el-table thead {
      color: #909399;
      font-weight: 500;
    }
    .el-table td,
    .el-table th.is-leaf {
      border-bottom: 1px solid rgba(132, 170, 255, 0.5);
    }
    .el-table th.is-leaf {
      background: linear-gradient(
        180deg,
        rgba(108, 151, 255, 0.2) 0%,
        rgba(107, 151, 255, 0.2) 48%,
        rgba(58, 116, 255, 0.1) 100%,
        #0049fa 100%,
        #0049fa 100%
      ) !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.inout_detail_top {
  height: 90px;
  display: flex;
  justify-content: space-between;
  background-color: #000;
  .selfClose_btn {
    position: relative;
    right: 78px;
  }
}
.detail_title {
  width: 350px;
  height: 60px;
  font-size: 26px;
  font-weight: 500;
  color: #f5a623;
  line-height: 57px;
  border-bottom: solid 2px #f5a623;
  text-align: center;
  // position: absolute;
  // left: 0;
  // top: 0;
}
.list_overview_detail {
  background: #000000;
  box-shadow: 0px 10px 20px 0px rgba(74, 144, 226, 0.31);
  border-radius: 2px;
  // position: relative;
  // left:50%;
  // top: 20px;
  // transform: translateX(-50%);
  height: 850px;
  overflow-y: auto;
  padding: 50px;
  // z-index: 23;

  .account {
    background: rgba(0, 59, 58, 0.7);
    border: 1px solid rgba(5, 255, 250, 0.99);
    .account-title {
      font-size: 24px;
      font-weight: bold;
      color: #ffffff;
      line-height: 20px;
      background: url("./img/icon.png") no-repeat left center;
      padding-left: 35px;
      margin-bottom: 20px;
    }
  }

  .account {
    width: 100%;
    height: 100% !important;
    padding: 30px 50px;
    font-size: 20px;
      overflow-y: scroll;
    .basic-info {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin: 10px 0 40px 0;

      .basic-item {
        width: 33.3%;
        height: 60px;
        line-height: 60px;
        color: white;
        display: flex;
        //align-items: baseline;
        .item-label {
          font-size: 21px;
          font-weight: bold;
          color: #b8b8b8;
          line-height: 26px;
        }
        span {
          font-size: 21px;
          font-weight: bold;
          color: #f4c48f;
          line-height: 26px;
        }
        .special {
          font-size: 21px;
          font-weight: bold;
          color: #f4c48f;
          width: 260px;
          white-space: pre-wrap;
          word-wrap: break-word;
          display: inline-block;
          line-height: 1;
        }
        .item-limit {
          display: inline-block;
          height: 80px;
          white-space: pre-wrap;
          word-wrap: break-word;
          width: 260px;
        }
      }
    }
    .picture-info2 {
      margin-top: 40px;
    }
    .picture-info {
      margin-top: 40px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .picture-inner {
        width: 49%;
        margin-bottom: 25px;
        p {
          color: #a2d8ff;
          font-size: 22px;
          line-height: 130px;
          text-align: center;
        }

        .picture {
          padding: 10px;
          width: 100%;
          height: 340px;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          // background-image: url("../img/img_bg.png");
          position: relative;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            width: 100%;
            height: 100%;
          }

          span {
            font-weight: bold;
            color: #d7d7d7;
            font-size: 24px;
          }

          &:before {
            content: "";
            position: absolute;
            top: 20px;
            right: 20px;
            width: 54px;
            height: 54px;
            // background-image: url("./../img/enlarge.png");
          }
        }
      }
    }
  }
}

.absolute_center {
  padding-top: 80px;
}
</style>
